<template>
  <div
    v-if="!isEmpty(filters)"
    id="appliedFiltersSection"
    class="d-flex align-items-center text-nowrap mb-3"
  >
    <label class="mb-0 mr-2 applied-filtering-label">Applied filters: </label>
    <div class="d-flex justify-content-space-between button-wrapper">
      <div class="d-flex badge-wrapper bg-light pb-0 applied-filtering-content">
        <div
          class="d-flex mb-1 pr-2 border-right sorting-head"
          style="flex: 1"
        >
          <b-badge
            v-for="(filter , column) in filters"
            id="badge-text"
            variant="info"
            size="sm"
            class="mr-2 filter-item-badge"
            :class="{truncated: filter.text && filter.text.length > 10}"
          >
            <span v-if="filter.fieldType === 'recordStatus'">
              <span
                v-if="filter.selectedStatus.length"
                class="badge-text"
              >
                {{ filter.label }}: {{ getStatuses(filter.selectedStatus) }}
              </span>
              <span
                v-else
                class="badge-text"
              >
                {{ filter.label }} is Empty
              </span>
            </span>

            <span v-if="filter.fieldType === 'postedStatus'">
              <span
                v-if="filter.selectedPostedStatuses.length"
                class="badge-text"
              >
                {{ filter.label }}: {{ getPostedStatuses(filter.selectedPostedStatuses) }}
              </span>
              <span
                v-else
                class="badge-text"
              >
                {{ filter.label }} is Empty
              </span>
            </span>

            <span v-if="isFieldDateTime(filter)">
              <span
                v-if="filter.fromDate"
                class="badge-text"
              >
                {{ filter.label }} from {{ filter.fromDate }}
              </span>
              <span
                v-if="filter.toDate"
                class="badge-text"
              >
                {{ filter.label }} to {{ filter.toDate }}
              </span>
              <span
                v-if="!filter.toDate && !filter.fromDate"
                class="badge-text"
              >
                {{ filter.label }} is Empty
              </span>
            </span>


            <span v-if="filter.fieldType === 'selectColumn'">
              <span
                v-if="filter.createdDate"
                class="badge-text"
              >
                Created Date: {{ filter.createdDate }}
              </span>
              <span
                v-if="filter.updatedDate"
                class="badge-text"
              >
                Updated Date: {{ filter.updatedDate }}
              </span>
              <span
                v-if="!filter.createdDate && !filter.updatedDate"
                class="badge-text"
              >
                Created Date and Updated Date are Empty
              </span>
            </span>

            <span
              v-if="filter.fieldType === 'boolean'"
              class="badge-text"
            >
              {{ filter.label }} is {{ getFilterTypeBoolean(filter.selected) }}
            </span>

            <span
              v-if="isFieldInternal(filter)"
              class="badge-text"
            >
              {{ filter.label }}: {{ filter.text }}
            </span>

            <span v-if="['lookup', 'parentChildHierarchy', 'user'].includes(filter.fieldType)">
              <span
                v-if="filter.selectItems.length"
                v-b-tooltip.hover.bottom="filter.label + ' in ' + getFilterTypeLookup(filter)"
                class="badge-text"
              >
                {{ filter.label }} in {{ getFilterTypeLookup(filter) }}
              </span>
              <span
                v-else
                class="badge-text"
              >
                {{ filter.label }} is Empty
              </span>
            </span>

            <span v-if="['text', 'wholeNumber', 'decimalNumber', 'floatNumber'].includes(filter.fieldType)">
              <span
                v-if="filter.text"
                v-b-tooltip.hover.bottom="filter.label + ' ' + getFilterTypeText(filter.type)+ ' ' + filter.text"
                class="badge-text"
              >
                {{ filter.label }} {{ getFilterTypeText(filter.type) }} {{ filter.text }}
              </span>
              <span
                v-else
                class="badge-text"
              >
                {{ filter.label }} {{ getFilterTypeText(filter.type) }} Empty String
              </span>
            </span>
            <!--            <span v-else-if="filters.primaryKey" class="badge-text">-->
            <!--                  Primary Key Equals {{ computedPrimaryKeyIds(filters.primaryKey) }}-->
            <!--            </span>-->
            <span
              class="ml-1 delete-filter-item"
              @click="removeItemFromFilter(column)"
            >
              <font-awesome-icon :icon="['fas', 'times']" />
            </span>
          </b-badge>
        </div>
        <div class="pl-2 clear-button d-flex align-items-center">
          <b-button
            id="clearFilters"
            size="sm"
            variant="secondary"
            @click="clearMultiFilter()"
          >
            <font-awesome-icon :icon="['fas', 'times']" />
            Clear filters
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex';
import {capitalize} from 'lodash';

const {mapState} = createNamespacedHelpers('app');
const {mapState: mapStateDataManagement} = createNamespacedHelpers('dataManagement');

export default {
  name: 'FilterHeader',
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState([
      'filterOptions',
      'filterOptionsText',
    ]),
    ...mapStateDataManagement([
      'fieldValues',
    ]),
  },
  methods: {
    isEmpty(filters) {
      for (const key in filters) {
        if (filters.hasOwnProperty(key))
          return false;
      }
      return true;
    },
    removeItemFromFilter(column) {
      let updatedFilter = JSON.parse(JSON.stringify(this.filters));
      delete updatedFilter[column];
      if (this.isEmpty(updatedFilter)) {
        updatedFilter = {};
      }

      const params = {
        updatedFilter: updatedFilter,
        query: this.buildQuery(updatedFilter),
      };

      this.$emit('filter', params);
    },
    getFilterTypeLookup(filter) {
      // if (filter.fieldType === 'parentChildHierarchy') {
      //   return filter.selectItems.map((elem) => elem[filter.field.data.options.hierarchyField.display.name]).join(', ')
      // } else
      if (['lookup', 'user', 'parentChildHierarchy'].includes(filter.fieldType)) {
        return filter.selectItems.map((elem) => elem.text).join(', ');
      }
      return '';
    },
    async clearMultiFilter() {
      const params = {
        updatedFilter: {},
        query: this.buildQuery({}),
      };
      this.$emit('filter', params);
    },
    getFilterTypeBoolean(val) {
      val = parseInt(val);
      if (val === -1) {
        return 'All';
      } else if (val === 0) {
        return 'Unchecked';
      } else {
        return 'Checked';
      }
    },
    getStatuses(selectedStatus) {
      return selectedStatus.map(status => {
        return status === 'validationFailed' ? 'Validation Failed' : capitalize(status);
      }).join(', ');
    },
    getPostedStatuses(postedStatuses) {
      return postedStatuses.join(', ');
    },
    getFilterTypeText(filterType) {
      return this.filterOptionsText[filterType];
    },
    buildQuery(filters) {
      return {id: this.$route.params.tableId, filter: filters, limit: 20, offset: 0, page: 1};
    },
    isFieldDateTime(params) {
      return [this.fieldValues.date, this.fieldValues.dateTime, this.fieldValues.createdDate, this.fieldValues.lastUpdatedDate].includes(params.fieldType);
    },
    isFieldInternal(params) {
      return [this.fieldValues.lastUpdatedBy].includes(params.fieldType);
    },
    // computedPrimaryKeyIds(ids) {
    //   return ids.map(id => id).join(' and ');
    // },
  },
};
</script>

<style lang="scss" scoped>
.filter-head {
  max-width: 500px;
  overflow: auto;
}

.clear-button {
  padding-bottom: 0.3rem;
}

::-webkit-scrollbar {
  height: 7px;
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 1px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

.applied-filtering-label {
  width: 100px;
}
.applied-filtering-content {
  min-width: 240px;
}
.badge-text {
  display: flex;
  align-items: center;
}
.sorting-head {
  flex-wrap: wrap;
  gap: 1px;
}
.badge-text{
  max-width: 200px;
  overflow-x: hidden;
  text-overflow: ellipsis;
  min-height:20px;
  vertical-align: bottom;
}
</style>
